import * as TestInquiryWidget from './library/TestInquiryWidget';
import { UdpPages } from 'unity-fluent-library';

const widgets = { TestInquiryWidget, ...UdpPages };

export default widgets;
